var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGsfMailIcon = function SvgGsfMailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "gsf-mail-icon_svg__a",
    width: 21,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h20v20H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gsf-mail-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.09 16.25q-.633 0-1.07-.437a1.45 1.45 0 0 1-.437-1.07V5.256q0-.63.438-1.069a1.45 1.45 0 0 1 1.068-.437h12.82q.633 0 1.07.438.437.437.437 1.068v9.487q0 .633-.437 1.07a1.45 1.45 0 0 1-1.07.437zM17.165 6.202l-6.26 4.008a1 1 0 0 1-.2.086.7.7 0 0 1-.413 0 1 1 0 0 1-.199-.086L3.833 6.202v8.542a.25.25 0 0 0 .072.184.25.25 0 0 0 .184.072h12.82a.25.25 0 0 0 .185-.072.25.25 0 0 0 .072-.185zM10.5 9.167 17.038 5H3.961zM3.833 6.394v-.953.025-.026z"
  }))));
};
export default SvgGsfMailIcon;